import { Injectable } from '@angular/core';
import { SpsLogger } from '@lib/utils/logger/sps-logger';

@Injectable({
  providedIn: 'root',
})
export class IconService {
  private readonly customIcons: { [label: string]: string } = {
    'img-icon-download': null,
    'img-icon-linkedin': null,
    'img-icon-youtube': null,
    'img-icon-x': null,
    'img-icon-spotify': null,
  };

  public async getIcon(icon: string): Promise<string | null> {
    icon = icon.startsWith('img-icon') ? icon : `img-icon-${icon}`;

    if (!this.iconRegistered(icon)) {
      console.warn(`IconService: requested icon '${icon}' not registered.`);
      return null;
    }

    let svg: string = null;

    if (!this.iconLoaded(icon)) {
      svg = await this.loadIcon(icon);
      this.customIcons[icon] = svg;
    }

    return this.customIcons[icon];
  }

  private iconPath(icon: string): string {
    return `/assets/images/icons/custom/${icon}.svg`;
  }

  private async loadIcon(icon: string): Promise<string | null> {
    return fetch(this.iconPath(icon))
      .then(response => response.text())
      .catch(e => {
        SpsLogger.warn(`Error fetching icon '${icon}'. Error: ${e}`);
        return null;
      });
  }

  private iconLoaded(icon: string): boolean {
    return !!this.customIcons[icon];
  }

  private iconRegistered(icon: string): boolean {
    return Object.keys(this.customIcons).includes(icon);
  }
}
